import { ImportWorkspace } from "../import-workspace";

const FoodicsMenuPage = () => <ImportWorkspace mode="menu" />;

export default FoodicsMenuPage;
